import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  connectFirestoreEmulator,
  enableNetwork,
} from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase設定（環境変数から読み込み）
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'your-api-key',
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    'your-project-id.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'your-project-id',
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    'your-project-id.appspot.com',
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || 'your-sender-id',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || 'your-app-id',
};

// Firebase初期化
const app = initializeApp(firebaseConfig);

// サービス初期化
// オフライン永続化を無効化（問題の切り分けのため）
// データベースIDを明示的に指定（Functions側と同じく"default"）
export const db = getFirestore(app, 'default');

// ネットワーク接続を確実に有効化
enableNetwork(db).catch(error => {
  // eslint-disable-next-line no-console
  console.warn('Failed to enable Firestore network:', error);
});
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1');

// エミュレーター接続（開発環境のみ）
// 本番デプロイ時は false に設定
const useEmulators = false; // process.env.NODE_ENV === 'development';

if (useEmulators) {
  // 接続済みフラグをチェック
  const isConnected = (window as any).__firebaseEmulatorConnected;

  if (!isConnected) {
    try {
      // console.log('Connecting to Firebase emulators...');

      // Firestoreエミュレーター
      connectFirestoreEmulator(db, '127.0.0.1', 8080);
      // console.log('Firestore emulator connected');

      // Authエミュレーター
      connectAuthEmulator(auth, 'http://127.0.0.1:9099');
      // console.log('Auth emulator connected');

      // Functionsエミュレーター
      connectFunctionsEmulator(functions, '127.0.0.1', 5001);
      // console.log('Functions emulator connected');

      // 接続済みフラグを設定
      (window as any).__firebaseEmulatorConnected = true;
      // console.log('All Firebase emulators connected successfully');
    } catch (error) {
      // console.error('Failed to connect to emulators:', error);
      // エミュレーターが既に接続されている場合は無視
      if (
        error instanceof Error &&
        error.message.includes('already been called')
      ) {
        // console.log('Emulators already connected');
        (window as any).__firebaseEmulatorConnected = true;
      }
    }
  }
  // else {
  //   console.log('Firebase emulators already connected');
  // }
}

export default app;
